import React from "react";
import { TextField, InputAdornment, IconButton } from "@mui/material";
import { MdSearch } from "react-icons/md";

function SearchBox({ searchTerm, handleSearch }) {
  return (
    <div className="d-flex justify-content-start align-items-center">
    <TextField
      variant="outlined"
      size="small"
      placeholder="Search..."
      value={searchTerm}
      onChange={handleSearch}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <IconButton>
              <MdSearch />
            </IconButton>
          </InputAdornment>
        ),
      }}
      style={{ marginBottom: 16, width: 300 }}
    />
    </div>
  );
}

export default SearchBox;
